module.exports = __webpack_public_path__ + "static/media/img.app.35af53ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.MenuNew/Icon/img.app.svg
// module id = 7085
// module chunks = 0